import hash from 'object-hash';
import {document} from 'ssr-window';
import SentryUtils from '@spothero/utils/sentry';
import StorageUtils from '@spothero/utils/storage';
import SegmentUtils from 'utils/segment';
import GTMUtils from 'utils/gtm';
import {
    USER_LOGIN,
    USER_UPDATE,
    USER_LOGOUT
} from 'user/user-actions';
import UserUtils from 'user/user-utils';

let firstUserUpdate = true;

const getMediaSource = () => {
    if (document.referrer.search('https?://(.*)google.([^/?]*)') === 0) {
        return 'Google';
    } else if (document.referrer.search('https?://(.*)bing.([^/?]*)') === 0) {
        return 'Bing';
    } else if (document.referrer.search('https?://(.*)yahoo.([^/?]*)') === 0) {
        return 'Yahoo';
    } else if (document.referrer.search('https?://(.*)facebook.([^/?]*)') === 0) {
        return 'Facebook';
    } else if (document.referrer.search('https?://(.*)twitter.([^/?]*)') === 0) {
        return 'Twitter';
    } else {
        return 'Other';
    }
};

const segmentIdentify = user => {
    const segmentTraits = {
        'media source': getMediaSource(),
        'user id': user.id,
        email: user.email,
        created: user.dateJoined,
        name: user.displayName,
        'new user': user.justCreated,
        'referrer code': user.referralToken
    };
    const shExperimentVariations = StorageUtils.get('sh-experiment-variations', 'cookie');

    // register active experiments
    if (shExperimentVariations) {
        for (const key in shExperimentVariations) {
            if (Object.prototype.hasOwnProperty.call(shExperimentVariations, key)) {
                segmentTraits[`Experiment ${key}`] = shExperimentVariations[key];
            }
        }
    }

    SegmentUtils.identify({
        uniqueId: user.id,
        traits: segmentTraits
    });
};

const gtmIdentify = (user = null) => {
    if (user) {
        GTMUtils.push({
            event: 'userLoggedIn',
            userId: String(user.id),
            userEmailMD5: hash.MD5(user.email),
            userEmail: user.email,
            facebookOAuth: String(!user.hasUsablePassword)
        });
    } else {
        /* eslint-disable no-undefined */
        GTMUtils.push({
            event: 'userLoggedOut',
            /* eslint-disable no-undefined */
            userId: undefined,
            userEmailMD5: undefined,
            userEmail: undefined,
            facebookOAuth: undefined
            /* eslint-enable no-undefined */
        });
        /* eslint-enable no-undefined */
    }
};

export const userMiddleware = store => next => action => {
    switch (action.type) {
        case `${USER_LOGIN}_FULFILLED`: {
            const user = UserUtils.normalize({data: action.payload.data.data});

            segmentIdentify(user);
            gtmIdentify(user);

            SentryUtils.setUser({
                email: user.email,
                id: user.id
            });

            break;
        }

        case USER_UPDATE: {
            const storedUser = store.getState().user.data;
            const {
                payload
            } = action;
            const userLoggedInOnFirstUserUpdate = (firstUserUpdate && payload.status === UserUtils.AUTH_STATE.USER);
            const userLoggedInOnSubsequentUserUpdate = (
                storedUser.status !== payload.status &&
                payload.status === UserUtils.AUTH_STATE.USER
            );

            if (userLoggedInOnFirstUserUpdate || userLoggedInOnSubsequentUserUpdate) {
                segmentIdentify(payload);
                gtmIdentify(payload);

                SentryUtils.setUser({
                    email: payload.email,
                    id: payload.id
                });

                firstUserUpdate = false;
            }

            break;
        }

        case `${USER_LOGOUT}_FULFILLED`: {
            SentryUtils.setUser();
            StorageUtils.remove('sh-session-uuid', 'cookie');
            SegmentUtils.reset();
            gtmIdentify();

            break;
        }
    }

    return next(action);
};
